import type { ComponentPropsWithRef, ReactNode } from 'react'

import { cn } from '../lib/cn'
import { classesChamp } from './champ'

export interface InputProps extends ComponentPropsWithRef<'input'> {
  /** Bordure rouge + `aria-invalid`. Le message, lui, vit dans `<FormField>`. */
  readonly invalide?: boolean | undefined
  /** Décor à gauche du champ : loupe de recherche, « CHF »… */
  readonly prefixe?: ReactNode | undefined
  /** Décor à droite : unité, bouton d’effacement. */
  readonly suffixe?: ReactNode | undefined
}

export function Input({ invalide = false, prefixe, suffixe, className, ...reste }: InputProps) {
  const champ = (
    <input
      className={cn(
        classesChamp(invalide),
        prefixe !== undefined && 'pl-9',
        suffixe !== undefined && 'pr-9',
        className,
      )}
      aria-invalid={invalide || undefined}
      {...reste}
    />
  )

  if (prefixe === undefined && suffixe === undefined) return champ

  return (
    <div className="relative">
      {prefixe !== undefined && (
        <span className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-sm text-slate-500">
          {prefixe}
        </span>
      )}
      {champ}
      {suffixe !== undefined && (
        <span className="absolute inset-y-0 right-0 flex items-center pr-3 text-sm text-slate-500">
          {suffixe}
        </span>
      )}
    </div>
  )
}
